/**
 * Canonical URLs for the published legal documents.
 *
 * The customer app REFERENCES these pages; it deliberately does not host copies
 * of them. Three reasons:
 *
 *  1. There is one Privacy Policy, and it covers both or.chestrate.com and
 *     app.or.chestrate.com by name. A second rendering on a second origin is a
 *     drift surface where the two can silently disagree about what we do — and
 *     an inaccurate privacy policy is itself the legal exposure.
 *  2. The Terms of Use exist to be SUBORDINATE to the Master Service Agreement.
 *     Serving them from the application's own origin, to a signed-in customer
 *     user, is exactly the fact pattern their subordination clause is written to
 *     defeat. Keeping them on the marketing origin keeps that boundary visible.
 *  3. Publishing them from one place means one deploy (`./deploy.sh landing`)
 *     makes a correction live everywhere, instead of two that can drift apart.
 *
 * Absolute URLs, not relative paths: these point at a DIFFERENT origin from the
 * app. `REACT_APP_LEGAL_BASE_URL` exists only so a non-production build can aim
 * at a staging marketing site; the default is the real published site, because a
 * missing env var must not silently produce a dead legal link.
 */

const LEGAL_BASE_URL = (
  process.env.REACT_APP_LEGAL_BASE_URL || 'https://or.chestrate.com'
).replace(/\/+$/, '');

export const PRIVACY_POLICY_URL = `${LEGAL_BASE_URL}/privacy`;
export const TERMS_OF_USE_URL = `${LEGAL_BASE_URL}/terms`;

/** The links rendered on the app's unauthenticated screens, in display order. */
export const LEGAL_LINKS = [
  { label: 'Privacy Policy', href: PRIVACY_POLICY_URL },
  { label: 'Terms of Use', href: TERMS_OF_USE_URL },
] as const;
